module.exports = __webpack_public_path__ + "img/road_ cross.7aaccfe0.svg";